import { useBooleanFlagValue } from '@openfeature/react-sdk';

/** UFF flag, shared with ap_web (ExReports::ApprovesController). */
export const KEEP_APPROVAL_SEARCH_CONDITIONS_FLAG =
  'keep-approval-search-conditions';

/** Keep the Approval-list search conditions across Edit / Approve / Reject. */
export const useKeepApprovalSearchConditionsFlag = (): boolean =>
  useBooleanFlagValue(KEEP_APPROVAL_SEARCH_CONDITIONS_FLAG, false);
